<template>
     <Modal :is_show="is_show_modal" class="app-publish-modal" @click-bg="is_show_modal = false">
        <div class="big-header">
            <svg-icon class="close-svg" name="close" @click="is_show_modal = false"/>
        </div>
        <div class="box">
            <svg-icon class="header-svg" name="yes"/>
            <header class="delete-header">Your application is now live!</header>
            <p>Share this link to begin receiving submissions.</p>
            <div class="share-popup-menu--body" @click="copy(url)">
                <span class="link"> {{ url }}</span>
                <span class="btn">Copy</span>
            </div>
            <div class="btns">
                <ui-button type="button" :border_r="6" color="white" size="40" @click="is_show_modal=false">Done</ui-button>
                <ui-button type="button" :border_r="6" color="dark-blue" size="40" @click="goView(url)">View application</ui-button>
            </div>
        </div>
    </Modal>
</template>

<script>
import Modal from '@/components/ui/Modal.vue'
import copyToClipboard from 'copy-to-clipboard';

export default {
    name: 'ApplicationPublishModal',

    props:{
        url: {
            type: String,
            default: ''
        },
    },

    components: {
        Modal
    },

    methods: {
        open() {
            this.is_show_modal = true
        },

        close() {
            this.is_show_modal = false
        },

        copy(url) {
            copyToClipboard(url, {format:'text/plain'});
            this.$notify(`<svg><use xlink:href="#yes--sprite"></use></svg> Link copied`);
        },

        goView(url) {
            this.close();
            window.open(url, '_blank')
        }
    },

    data() {
        return {
            is_show_modal: false,

        }
    },


}
</script>
<style lang="scss">
.app-publish-modal{
    .ui-modal--container {
        width: 520px;
    }

    .box {
        padding: 24px;
        text-align: center;

        .share-popup-menu--body {
            padding: 16px 0;

            .link{
                text-align: left;
            }
        }

        header {
            font: var(--font-demi-20);
            color: var(--black-90);
            letter-spacing: 1px;
            margin-bottom: 8px;
        }

        p {
            font-size: 16px;
            color: var(--black-60);
        }

        .btns {
            display: flex;
            align-items: center;
            justify-content: flex-end;
        }
    }


    .big-header{
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 16px;

        .close-svg{
            width: 14px;
            height: 14px;
            margin-right: 2px;
            fill:var(--black-50);
            cursor: pointer;

            &:hover{
                fill:var(--black-90);
            }
        }
    }

    .header-svg {
        width: 48px;
        height: 48px;
        margin: auto;
        fill: var(--green);
        margin-bottom: 24px;
    }

    .btns {
        justify-content: center;

        .ui-button{
            width: 50%;

            &:last-child{
                margin-left: 8px;
            }
        }
    }

}
</style>
